import { observable, action } from "mobx";

import { redirect } from "@state";
import RootStore from "@state/stores/RootStore";
import { getCurrentCulture } from "@utils";
import { StorageStateKeysEnum } from "@utils/storage";

type TRootStore = {
	localStorageProvider: RootStore["localStorageProvider"];
	userAuthStore: RootStore["userAuthStore"];
};

class OnboardingRegisterStore {
	@observable isActive: boolean = false;

	rootStore: TRootStore;

	constructor(rootStore: TRootStore) {
		this.rootStore = rootStore;
	}

	@action.bound
	showPopup() {
		this.isActive = true;

		this.rootStore.localStorageProvider.set(
			StorageStateKeysEnum.ONBOARDING_REGISTER_POPUP,
			JSON.stringify(true)
		);
	}

	@action.bound
	hidePopup() {
		this.isActive = false;
	}

	@action.bound
	onOnboardingRedirection() {
		this.hidePopup();

		this.rootStore.localStorageProvider.set(
			StorageStateKeysEnum.ONBOARDING_REGISTER_POPUP,
			JSON.stringify(true)
		);

		redirect(`/${getCurrentCulture()}/auth/register`);
	}
}

export default OnboardingRegisterStore;
